/* global axios */
import ApiClient from './ApiClient';

class AipayOKSupportAPI extends ApiClient {
  constructor() {
    super('aipayok_support', { accountScoped: true });
  }

  show(conversationId) {
    return axios.get(this.url, {
      params: { conversation_id: conversationId },
    });
  }

  search(query) {
    return axios.get(`${this.url}/search`, { params: { q: query } });
  }

  proactiveContact(payload) {
    return axios.post(`${this.url}/proactive_contact`, payload);
  }
}

export default new AipayOKSupportAPI();
